import React from 'react';
// images
import desktopImageWebp from './images/business-services-hero.webp';
import desktopImageMobileWebp from './images/business-services-hero-mobile.webp';
// styles
import { FlexibleHeroStyled } from './styles';

export default () => {
  return (
    <FlexibleHeroStyled
      sectionId='business-services-page-flexible-hero'
      headingText='Business Services'
      headingTextPosition='left'
      desktopImage={desktopImageWebp.toString()}
      mobileImage={desktopImageMobileWebp.toString()}
      desktopImageLowRes='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      mobileImageLowRes='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    />
  );
};
